module.exports = __webpack_public_path__ + "static/media/025-video-call.cd28d217.svg";